export default __webpack_public_path__ + "static/media/backgroundBanner.62688486.png";